import React, { useState } from "react";
import { HiMiniArrowUpCircle, HiMiniArrowDownCircle } from "react-icons/hi2";
import "./admission_proc.css";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const AdmissionProc = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const cardData = [
    {
      logo: "/assets/images/icons/user.webp",
      title: "Register Yourself",
      subtitle: "step 1",
    },
    {
      logo: "/assets/images/icons/email.webp",
      title: "Verify Email",
      subtitle: "step 2",
    },
    {
      logo: "/assets/images/icons/fill_form.webp",
      title: "Fill the Form",
      subtitle: "step 3",
    },
    {
      logo: "/assets/images/icons/pay_fee.webp",
      title: "Pay Fee",
      subtitle: "step 4",
    },
    {
      logo: "/assets/images/icons/submit.webp",
      title: "Submit Application",
      subtitle: "step 5",
    },
  ];

  const admissionTeam = [
    {
      name: "Prof. Sunil Chawale",
      desg: "HOD Admissions",
      mobile: "7774062352",
    },
    {
      name: "Mr. Nilesh Jagtap",
      desg: "Admission Coordinator",
      mobile: "8308010405",
    },
    {
      name: "Ms. Priti Deshmukh",
      desg: "Admission Counsellor",
      mobile: "7774062351",
    },
    {
      name: "Ms. Avantika Dharangaonkar",
      desg: "Admission Counsellor",
      mobile: "7774062353",
    },
    {
      name: "Ms. Swapna Navale",
      desg: "Admission Counsellor",
      mobile: "7774062354",
    },
    {
      name: "Ms. Arti Bhosale",
      desg: "Admission Counsellor",
      mobile: "8983185778",
    },
    {
      name: "Mr. Baliram Maske",
      desg: "Admission Counsellor",
      mobile: "7391095155",
    },
  ];

  return (
    <div>
      <h1 className="title">Admission Procedure</h1>
      <hr />
      {/* ---------- Accordion 1 ---------- */}
      <Accordion
        title="How To Apply ?"
        isActive={activeIndex === 0}
        onClick={() => handleToggle(0)}
      />
      {activeIndex === 0 && (
        <div className="accordion-content">
          <p>
            Note- For application to MANET, the candidate must have successfully
            completed the Senior Secondary Examination (10+2) or its equivalent
          </p>

          <div className="process-top-section">
            <ul className="page-content-lists">
              <li>
                At least 60% marks in Physics, Chemistry and Mathematics
                (PCM)
              </li>
              <li>
                At least 50% marks in English either in Class X or Class XII
              </li>
            </ul>
            <div className="process-top-right">
              <h2 className="subtitle" style={{ margin: "10px" }}>
                For Admission Details
              </h2>
              <a href="tel:9595996611">
                <button>Call to 9595996611</button>
              </a>
            </div>
          </div>

          {/* cards */}
          <div className="common-cards-container">
            {cardData.map((card, index) => (
              <div className="common-cards" key={index}>
                <img
                  src={card.logo}
                  alt={card.title}
                  className="process-icons"
                  style={{ backgroundColor: "goldenrod", padding: "2px clamp(5px, 1vw, 10px)", height: "clamp(40px, 5vw, 80px)" }}
                />
                <h1 className="common-cards-title" style={{ fontSize: "clamp(12px, 1.5vw, 20px)", margin: "0px" }}>{card.title}</h1>
                <h2 className="subtitle" style={{ margin: "0px" }}>{card.subtitle}</h2>
              </div>
            ))}
          </div>

          <table className="page-content-table">
            <thead>
              <tr>
                <th>Admission Team Member</th>
                <th>Designation</th>
                <th>Mobile No.</th>
              </tr>
            </thead>
            <tbody>
              {admissionTeam.map((member, index) => (
                <tr key={index}>
                  <td>{member.name}</td>
                  <td>{member.desg}</td>
                  <td>
                    <a href={`tel:${member.mobile}`}>{member.mobile}</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ---------- Accordion 2 ---------- */}
      <Accordion
        title="Shortlisting Candidates"
        isActive={activeIndex === 1}
        onClick={() => handleToggle(1)}
      />
      {activeIndex === 1 && (
        <div className="accordion-content">
          <p>
            Applicants will be shortlisted on the basis of their PCM marks and
            Medical fitness as per the DGS norms and they are called to
            MANET,Pune to confirm their admission in the month of Jun-July 2026
            (tentatively).
          </p>
        </div>
      )}

      {/* ---------- Accordion 3 ---------- */}
      <Accordion
        title="Personal Interview"
        isActive={activeIndex === 2}
        onClick={() => handleToggle(2)}
      />
      {activeIndex === 2 && (
        <div className="accordion-content">
          <p>
            Applicants are interviewed by a panel of educators and maritime
            professionals to assess the applicant's communication skills,
            leadership potential, clarity of thought, maturity and reasoning
            abilities. The panel also looks for any extracurricular achievements
            of the candidate.
          </p>
        </div>
      )}

      {/* ---------- Accordion 4 ---------- */}
      <Accordion
        title="Medical Examination"
        isActive={activeIndex === 3}
        onClick={() => handleToggle(3)}
      />
      {activeIndex === 3 && (
        <div className="accordion-content">
          <p>
            Medical practitioners appointed by DG Shipping will examine all
            selected candidates for certifying conformation with the medical
            requirements laid down by the Institute.
          </p>
          <div className="page-content-container" id="page-links">
            <p> DG Approved Doctor List: </p>
            <button>    <a
              className="btn-link"
              href="https://drive.google.com/file/d/1yrCFHHEG5RNRqOpuNBtZzzbaUbAJfrOH/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a></button>

          </div>
        </div>
      )}

      {/* ---------- Accordion 5 ---------- */}
      <Accordion
        title="Copies of Certificates"
        isActive={activeIndex === 4}
        onClick={() => handleToggle(4)}
      />
      {activeIndex === 4 && (
        <div className="accordion-content">
          <p>
            Copies of Certificates in Original and 3 sets of attested Xerox
            copies required for MANET Pune Admission Procedure
          </p>

          <h4 className="innerpage-subheading">Attestation Requirements:</h4>
          <ul className="page-content-lists ">
            Attestation by either the Principal of your (10+2) School or Gazette
            Officer of the Government of India only.
          </ul>
          <ul className="page-content-lists ">
            <b>Self-attested copies of the following documents:</b>
            <li>Passport</li>
            <li>Matriculation/Secondary School Certificate and marks sheet</li>
            <li>
              Higher Secondary/Intermediate/Senior Secondary (10+2) Certificate
              and marks sheet. (If a hard copy of class XII mark sheet is not
              received from your school at the time of admission round, then you
              can get the downloaded copies of class XII mark sheet from the
              Internet attested by your school Principal only.)
            </li>
            <li>Transfer Certificate from the institution last studied</li>
            <li>
              Migration Certificate (N.A for students studied in Maharashtra)
            </li>
            <li>
              Domicile Certificate (Applicable for students studied in
              Maharashtra)
            </li>
            <li>Caste Certificate</li>
            <li>Caste-Validity Certificate</li>
            <li>Date of Birth Certificate</li>
            <li>Non-creamy Layer certificate (If Applicable)</li>
            <li>GAP Certificate (If Applicable)</li>
            <li>Aadhar Card</li>
            <li>
              Copies of certificates for sports and any other extra-curricular
              activities, if available (from Std. VII and above only).
            </li>
          </ul>

          <p className="page-content-note">
            <b>Note:</b> Out of the above-mentioned certificates, Transfer
            certificate, Migration Certificate may be submitted within 15 days
            from the date of admission
          </p>
        </div>
      )}
    </div>
  );
};

export default AdmissionProc;
